import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './VehicleCoverage.metadata.json5';
import styles from '../PolicyVehiclesDriversInfo.module.scss';
import { NumberValue} from "@jutro/components";
import { IntlContext } from '@jutro/locale';



function VehicleCoverage({ data, show }) {
    const intl = useContext(IntlContext);

    function getCell(items, index, property) {
        return !_.isObject(items[property.id]) ? items[property.id] : null;
    }
    function getCurrencyCell(items, index, property) {
        return (
            <b>{
                items[property.id] ? 
                <NumberValue
                    format="decimal"
                    id="NumberValue"
                    maximumFractionDigits={2}
                    placeholder="-"
                    prefix=""
                    showFractions
                    showGrouping
                    suffix=".00"
                    tag="div"
                    value={items[property.id].amount }
                />
                : <span>-</span>
            }
            </b>
            
        );
    }

    if (_.isEmpty(data)) {
        return null;
    }


    const overrides = {
        vehicleCoverageInfo: {
            data: data,
            visible: show
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            getCellCoverage: getCell,
            getCellCurrencyCoverage: getCurrencyCell
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

VehicleCoverage.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
VehicleCoverage.defaultProps = {
    data: [],
    show: false
};
export default VehicleCoverage;
